export default __webpack_public_path__ + "static/media/smartobject_scratch.481d693c.png";